// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2fJi9","filesListContainer":"PosDisputesFiles_filesListContainer__2SB6i","filesButton":"PosDisputesFiles_filesButton__1050N"};